// account others
import request from '@/utils/request';

const serverUrl = process.env.VUE_APP_BASE_API;
const account = {
  // 获取银行logo
  getBankLogo(data) {
    return request({
      url: `${serverUrl}/visa/latam/index/v2/getLogo`,
      method: 'POST',
      data,
    });
  },
  // 收藏权益列表
  getFvList(data) {
    return request({
      url: `${serverUrl}/visa/latam/web/benefit/favorite/list`,
      method: 'POST',
      data,
    });
  },

  // 取消收藏权益
  cancelFv(data) {
    return request({
      url: `${serverUrl}/visa/latam/web/benefit/favorite/cancel`,
      method: 'POST',
      data,
    });
  },

  // 消费记录列表
  getCsList(data) {
    return request({
      url: `${serverUrl}/visa/latam/comsumerecord/list`,
      method: 'POST',
      data,
    });
  },

  // 登录历史
  getHistoryList(data) {
    return request({
      url: `${serverUrl}/visa/latam/login/history`,
      method: 'POST',
      data,
    });
  },

  // 修改用户邮件语言
  updateEmailLang(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/updateEmailLang`,
      method: 'POST',
      data,
    });
  },

  // 获取用户邮件语言
  getEmailLang(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/getUserInfo`,
      method: 'POST',
      data,
    });
  },

  // 获取用户邮件语言列表
  emailLangList(data) {
    return request({
      url: `${serverUrl}/visa/latam/langeSetting/email/lang/list`,
      method: 'POST',
      data,
    });
  },

  // 获取用户的MFA信息和手机邮件验证信息
  getMFAStatus(data) {
    return request({
      url: `${serverUrl}/visa/latam/user/getUserContact`,
      method: 'POST',
      data,
    });
  },

  // 发送短信，邮件验证码
  sendAuthCode(data) {
    return request({
      url: `${serverUrl}/visa/latam/otp/sendAuthCodeV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 校验验证码
  checkAuthCode(data) {
    return request({
      url: `${serverUrl}/visa/latam/otp/checkAuthCodeV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 更改用户MFA状态
  updateMft(data) {
    return request({
      url: `${serverUrl}/visa/latam/otp/updateMfa`,
      method: 'POST',
      data,
    });
  },

  // trips列表接口
  getTripsList(data) {
    return request({
      url: `${serverUrl}/visa/latam/trips/order/list/v2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // trips详情接口
  getTripsDetail(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/detailV2`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 取消prebooking
  cancelBooking(data) {
    return request({
      url: `${serverUrl}/visa/latam/booking/lounge/order`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },

  // 获取帮助图标的动态文案
  getHelpIcon(data) {
    return request({
      url: `${serverUrl}/visa/latam/index/getHelpIcon`,
      method: 'POST',
      data,
      headers: {
        'Content-Type': 'application/json',
      },
    });
  },
};

export default account;
